import { InteractionButton } from "../../lib/ui/toolbar/buttons";
export class MeasureAreaButton extends InteractionButton {
    constructor() {
        super('ruler-combined', 'Measure Area', 'areaBtn');
        this.set_interaction('area');
    }
}
